import { DEFAULT_NO_OWNER_USER } from 'utils/constants';
import { User } from './types';
import { LoggedUser } from '../types';
import { listGet } from 'utils/array';

export function isLeader(user: { type: User['type'] }): boolean {
  return user.type === 'LEADER';
}

interface EntityWithOwnership {
  owner: User | string;
  subOwner?: User | string;
}

function getId(target: User | string | undefined | null) {
  return typeof target === 'string' ? target : target?.id;
}

export function isOwner(
  item: EntityWithOwnership | undefined | null,
  user: { id: string },
): boolean {
  return [getId(item?.owner), getId(item?.subOwner)].some((id) => id === user.id);
}

export function hasOwner(item: EntityWithOwnership | undefined | null): boolean {
  return getId(item?.owner) !== DEFAULT_NO_OWNER_USER.id;
}

export function hasTogglePermission(user: LoggedUser, target: string | { team: string }) {
  if (user.isSysAdmin) return true;

  const targetId = typeof target === 'string' ? target : target.team;

  return user.team.id === targetId && isLeader(user);
}

export function isCurrentlyOnSecondaryTeam({
  originalTeam,
  team,
  secondaryTeams = [],
}: LoggedUser) {
  const isCurrentSecondary =
    (originalTeam && originalTeam !== team.id) || !!listGet(secondaryTeams, team?.id);

  return !!isCurrentSecondary;
}
